module.exports = __webpack_public_path__ + "img/minimize_icon.fcecf3f0.svg";